import type {InputHTMLAttributes} from 'react';

/** Поле ввода как в образце: подпись сверху, тёмное скруглённое поле, ошибка под полем. */
export function Field({
  label,
  id,
  error,
  className = '',
  ...rest
}: {label: string; error?: string} & InputHTMLAttributes<HTMLInputElement>) {
  const fieldId = id ?? `field-${label}`;
  return (
    <label htmlFor={fieldId} className="flex flex-col gap-2">
      <span className="text-[14px] text-muted-foreground">{label}</span>
      <input
        id={fieldId}
        aria-invalid={error ? true : undefined}
        {...rest}
        className={`h-[52px] w-full rounded-2xl border bg-[#141416] px-4 text-[15px] text-foreground outline-none transition-colors placeholder:text-muted-foreground/60 focus:border-white/35 ${
          error ? 'border-red-400/70' : 'border-white/10'
        } ${className}`}
      />
      {error ? <span className="text-[13px] text-red-300">{error}</span> : null}
    </label>
  );
}
